import React, {useContext, useMemo} from 'react';
import {AuthContext} from "../../../shared/contexts/authContext";
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import {PlayerContext} from "../../../shared/contexts/playerContext";
import {useItemKrTextData} from "../../probability/useItemData";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import {getGoodsLogColumns} from "../../logs/columns/goodsLogColumns";

const PlayerGoodsLog = () => {
    const { currentUser } = useContext(AuthContext);
    const { playerData } = useContext(PlayerContext);

    const { data: krItemTextData, isLoading, error } = useItemKrTextData();

    const defaultSearchParams = {
        begin: dayjs().subtract(7, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        userKey: playerData.userKey,
        logType: 'goods_log',
        isUnix: false
    };

    const paramTypeList = [
        {label: 'PID', value: 'pId'},
        {label: '아이템 ID', value: 'itemId'},
    ];

    const columns = useMemo(() => getGoodsLogColumns(krItemTextData, currentUser),[krItemTextData, currentUser]);

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error}/>;
    return (
        <LogTemplate
            columns={columns}
            defaultSearchParams={defaultSearchParams}
            paramTypeList={paramTypeList}
            routerUrl={'/logs'}
            logName={'GoodsLog'}
        />
    );
};

export default PlayerGoodsLog;